import { MainRoutes } from "ui/common/router/MainRouter.types";
import { RoleType } from "common/models/role/Role";

export type DefaultMainPageByRole = Record<RoleType, MainRoutes>;

export const DEFAULT_MAIN_PAGE_BY_ROLE: DefaultMainPageByRole = {
    [RoleType.ORGANIZATION_OWNER]: MainRoutes.MAIN,
    [RoleType.PROGRAM_MANAGER]: MainRoutes.USERS,
    [RoleType.PARTNER]: MainRoutes.TRANSACTIONS,
    [RoleType.OPERATION_MANAGER]: MainRoutes.MAIN,
    [RoleType.CUSTOMER_SERVICE]: MainRoutes.MAIN,
};
